const SvgIconInfo = (props) => {
  const { width = 20, height = 20, enableViewBox = true, iconFillColor = "#34657F", ...otherProps } = props;
  return (
    <svg
      width={width}
      height={height}
      {...(enableViewBox && { viewBox: `0 0 ${width + 4} ${height + 4}` })}
      {...otherProps}
    >
      <path
        d="M12 24c6.627 0 12-5.371 12-12 0-6.625-5.373-12-12-12S0 5.375 0 12c0 6.629 5.373 12 12 12zm0-14.613a2.032 2.032 0 110-4.065 2.032 2.032 0 010 4.065zm2.129 8.807H9.871a.58.58 0 01-.58-.581v-1.161a.58.58 0 01.58-.581h.58v-3.097h-.58a.58.58 0 01-.58-.58v-1.162c0-.32.26-.58.58-.58h3.097c.32 0 .58.26.58.58v4.839h.581c.32 0 .58.26.58.58v1.162c0 .32-.26.58-.58.58z"
        fill={iconFillColor}
        fillRule="nonzero"
      />
    </svg>
  );
};

export default SvgIconInfo;
